import { Component } from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import { Router } from '@angular/router';

import { environment } from '../environments';
import { SessionService } from 'app/api/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  providers: [ SessionService ]
})
export class AppComponent {
  constructor(private http: Http,
              private router: Router,
              private session: SessionService) {}

  ngOnInit() {
    const headers = new Headers({ 'Content-Type': 'application/json' });

    // Append `Authorization` headers.
    const token: string = this.session.token;
    if (token) {
      headers.append('Authorization', `Bearer ${token}`);

      const options = new RequestOptions({headers: headers});

      this.http.get(environment.apiUrl + '/g/users/session', options)
        .subscribe(res => {
          const user = res.json();
          if (user.session_expired) {
            this.session.clear();
            this.router.navigate(['/login'], {queryParams: {app_updated: true}});
          }
          if (user.password_expired) {
            this.router.navigate(['/login/update-password'], {queryParams: {update_msg: true}});
          }
      });
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts